import { FC } from "react";
import { useHistory } from "react-router";

import { Alert, Button, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { AgentsRoutes } from "routes/agents/constants";
import { AutomationsRoutes } from "routes/automations/constants";
import { SettingsRoutes } from "routes/settings/constants";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  teamsToRemove: number;
  forwardingAddressesToRemove: number;
  replyAddressesToRemove: number;
  customDomainsToRemove: number;
  emailTemplatesToRemove: number;
  workflowsToDeactivate: number;
  sharedMacrosToRemove: number;
  customFieldsToDeactivate: number;
}

const DowngradeAlerts: FC<IProps> = ({
  teamsToRemove,
  forwardingAddressesToRemove,
  replyAddressesToRemove,
  customDomainsToRemove,
  emailTemplatesToRemove,
  workflowsToDeactivate,
  sharedMacrosToRemove,
  customFieldsToDeactivate,
}) => {
  const history = useHistory();

  return (
    <Flex column gap={withVar(SpacingToken.Spacing2)}>
      <Text css={{ marginBottom: withVar(SpacingToken.Spacing1) }}>
        The Business plan has higher capabilities. To downgrade, you need to remove the following:
      </Text>
      {teamsToRemove > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(AgentsRoutes.Teams)}>
            Remove
          </Button>{" "}
          {teamsToRemove} {plural(teamsToRemove, "team", "teams")}
        </Alert>
      )}
      {forwardingAddressesToRemove > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(SettingsRoutes.ForwardingAddresses)}>
            Remove
          </Button>{" "}
          {forwardingAddressesToRemove}{" "}
          {plural(forwardingAddressesToRemove, "forwarding address", "forwarding addresses")}
        </Alert>
      )}
      {replyAddressesToRemove > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(SettingsRoutes.ReplyAddresses)}>
            Remove
          </Button>{" "}
          {replyAddressesToRemove} {plural(replyAddressesToRemove, "reply address", "reply addresses")}
        </Alert>
      )}
      {customDomainsToRemove > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(SettingsRoutes.CustomDomains)}>
            Remove
          </Button>{" "}
          {customDomainsToRemove} {plural(customDomainsToRemove, "custom domain", "custom domains")}
        </Alert>
      )}
      {emailTemplatesToRemove > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(SettingsRoutes.EmailTemplates)}>
            Remove
          </Button>{" "}
          {emailTemplatesToRemove} {plural(emailTemplatesToRemove, "email template", "email templates")}
        </Alert>
      )}
      {workflowsToDeactivate > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(SettingsRoutes.Workflows)}>
            Turn off
          </Button>{" "}
          {workflowsToDeactivate} {plural(workflowsToDeactivate, "rule", "rules")}
        </Alert>
      )}
      {customFieldsToDeactivate > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(SettingsRoutes.CustomFields)}>
            Deactivate
          </Button>{" "}
          {customFieldsToDeactivate} {plural(customFieldsToDeactivate, "custom field", "custom fields")}
        </Alert>
      )}
      {sharedMacrosToRemove > 0 && (
        <Alert>
          <Button kind="link-light" onClick={() => history.push(AutomationsRoutes.Macros)}>
            Remove
          </Button>{" "}
          {sharedMacrosToRemove} {plural(sharedMacrosToRemove, "shared macro", "shared macros")}
        </Alert>
      )}
    </Flex>
  );
};

export { DowngradeAlerts };
